// extracted by mini-css-extract-plugin
export default {"container":"SignOut_container__u64LC","button":"SignOut_button__ScxCP","heading":"SignOut_heading__GRcAo","text":"SignOut_text__gR0JS"};